import React from 'react';
import { DollarSign, ChevronRight, BarChart3 } from 'lucide-react';

interface PlanData {
    id: number;
    name: string;
    price: number;
    subscribers: number;
    revenue: number;
}

interface BotRevenueData {
    bot_id: number;
    bot_name: string;
    total_revenue: number;
    plans: PlanData[];
}

interface RevenueBotListProps {
    data: BotRevenueData[];
    loading: boolean;
}

export const RevenueBotList: React.FC<RevenueBotListProps> = ({ data, loading }) => {
    return (
        <div style={{
            background: 'var(--glass-bg)',
            backdropFilter: 'blur(12px)',
            WebkitBackdropFilter: 'blur(12px)',
            border: 'var(--glass-border)',
            borderRadius: 'var(--radius)',
            padding: '24px',
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            overflow: 'hidden'
        }}>
            <h3 style={{
                fontSize: '18px',
                fontWeight: 600,
                color: '#fff',
                marginBottom: '20px',
                display: 'flex',
                alignItems: 'center',
                gap: '10px'
            }}>
                <div style={{ background: 'rgba(34, 197, 94, 0.1)', padding: '6px', borderRadius: '8px', display: 'flex' }}>
                    <BarChart3 size={18} color="#22c55e" />
                </div>
                Faturamento por Serviço
            </h3>

            {loading ? (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                    {[1, 2, 3].map(i => (
                        <div key={i} className="shimmer-loading" style={{ height: '80px', borderRadius: '12px', width: '100%' }}></div>
                    ))}
                </div>
            ) : data && data.length > 0 ? (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', overflowY: 'auto', paddingRight: '4px' }} className="custom-scrollbar">
                    {data.map(bot => (
                        <div key={bot.bot_id} style={{
                            background: 'rgba(255, 255, 255, 0.02)',
                            border: '1px solid rgba(255, 255, 255, 0.04)',
                            borderRadius: '12px',
                            padding: '16px',
                            transition: 'all 0.2s ease',
                            cursor: 'pointer'
                        }}
                            className="bot-revenue-item"
                        >
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: bot.plans.length > 0 ? '12px' : '0' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <div style={{ width: '32px', height: '32px', borderRadius: '8px', background: 'rgba(255, 106, 0, 0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <DollarSign size={16} color="#ff6a00" />
                                    </div>
                                    <div style={{ fontSize: '15px', fontWeight: 600, color: '#f4f4f5' }}>
                                        {bot.bot_name}
                                    </div>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                    <div style={{ fontSize: '16px', fontWeight: 700, color: '#22c55e' }}>
                                        R$ {bot.total_revenue.toFixed(2)}
                                    </div>
                                    <ChevronRight size={16} color="#666" />
                                </div>
                            </div>

                            {bot.plans.length > 0 && (
                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '8px',
                                    paddingTop: '12px',
                                    borderTop: '1px solid rgba(255, 255, 255, 0.04)'
                                }}>
                                    {bot.plans.map(plan => (
                                        <div key={plan.id} style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px' }}>
                                            <span style={{ color: 'var(--text-muted)' }}>{plan.name} <span style={{ opacity: 0.5 }}>({plan.subscribers} ass.)</span></span>
                                            <span style={{ color: '#e4e4e7', fontWeight: 500 }}>R$ {plan.revenue.toFixed(2)}</span>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            ) : (
                <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '32px', textAlign: 'center' }}>
                    <div style={{ width: '64px', height: '64px', borderRadius: '50%', background: 'rgba(255,255,255,0.03)', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '16px' }}>
                        <DollarSign size={24} color="#555" />
                    </div>
                    <div style={{ color: '#a1a1aa', fontSize: '15px', fontWeight: 500, marginBottom: '8px' }}>Nenhum faturamento registrado</div>
                    <div style={{ color: '#52525b', fontSize: '13px', maxWidth: '80%' }}>Quando seus bots gerarem receita, os dados aparecerão aqui.</div>
                </div>
            )}
        </div>
    );
};
